/**
 * Service worker registration.
 *
 * Best-effort: failures are logged, not surfaced. The app remains usable
 * without the SW; only offline cold-start is degraded.
 *
 * Routing of user actions through the codebase:
 *
 *   client/src/main.ts -> registerServiceWorker()
 *      -> navigator.serviceWorker.register('/sw.js')
 *      -> on update available, dispatches `squid:sw-update` on `window`
 *         which the settings UI can listen for to prompt a reload.
 */

export async function registerServiceWorker(): Promise<void> {
	if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) {
		return;
	}
	// Skip during local dev with the Vite HMR client; the SW caches stale
	// modules and breaks reload-on-edit. Re-enable via VITE_PWA=1 when
	// validating the install path.
	if (import.meta.env.DEV && !import.meta.env.VITE_PWA) {
		return;
	}
	try {
		const reg = await navigator.serviceWorker.register("./sw.js");
		reg.addEventListener("updatefound", () => {
			const installing = reg.installing;
			if (!installing) return;
			installing.addEventListener("statechange", () => {
				if (installing.state === "installed" && navigator.serviceWorker.controller) {
					window.dispatchEvent(new CustomEvent("squid:sw-update"));
				}
			});
		});
	} catch (err) {
		console.warn("[squid] service worker registration failed", err);
	}
}
